import { render, staticRenderFns } from "./OurStaffListPage.vue?vue&type=template&id=beef5a56&"
import script from "./OurStaffListPage.vue?vue&type=script&lang=ts&"
export * from "./OurStaffListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports